'use strict';

// Get current wishlist selection
$(document).ready(function () {
    const getWishlistElement = $('.wishlist-get-list');
    if (getWishlistElement.length > 0 && getWishlistElement.data('url')) {
        const url = getWishlistElement.data('url');
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                if (data && data.list && data.list.items) {
                    data.list.items.forEach(product => {
                        const productTile = $('[data-pid="' + product.pid + '"]');

                        const wishlistSpan = productTile.find('span.icon-wishlist');
                        if (wishlistSpan.length > 0) { // The heart icon is in the product tile
                            wishlistSpan.addClass('hom-icon-favorite-filled');
                        } else { // The heart icon is in the header
                            const wishlistHeader = $('i.wishlistTile');
                            if (wishlistHeader.length > 0) {
                                wishlistHeader.addClass('hom-icon-favorite-filled');
                            }
                        }
                    });
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    }
});
